import React, { useCallback, useState } from 'react'
import { Input, Row, Select, Space } from 'antd'
import { size } from 'lodash'
import PropTypes from 'prop-types'

import { DROPDOWN_MIN_WIDTH, INGREDIENT_KEYWORD_TYPES } from '../../constants'
import { filterSelectOptions } from '../../utils'
import { StyledVerticalSpace } from '../styled'

import IngredientKeywordTree from './ingredient-keyword-tree'

const IngredientKeywordTable = ({
  editable,
  checkable,
  data,
  checkedKeywordNodesGroupedByType,
  onAdd,
  onRename,
  setDataForRenaming,
  onCheck,
  dataForRenaming,
  languageOptions,
  checkStrictly,
}) => {
  const [languageIdsFilter, setLanguageIdsFilter] = useState([])
  const [searchValue, setSearchValue] = useState(null)

  const { synonyms, varieties, uncategorized, discarded } = data

  const {
    synonyms: checkedSynonyms,
    varieties: checkedVarieties,
    discarded: checkedDiscarded,
    uncategorized: checkedUncategorized,
  } = checkedKeywordNodesGroupedByType

  const handleFilterKeywordsBySearchValue = useCallback(event => {
    setSearchValue(event.target.value)
  }, [])

  const maxTagPlaceholder = useCallback(
    omittedValues => `and ${size(omittedValues)} more selected`,
    [],
  )

  return (
    <StyledVerticalSpace>
      <Space>
        <Select
          style={{ minWidth: DROPDOWN_MIN_WIDTH }}
          allowClear
          showSearch
          mode="multiple"
          filterOption={filterSelectOptions}
          options={languageOptions}
          value={languageIdsFilter}
          maxTagCount={2}
          maxTagPlaceholder={maxTagPlaceholder}
          onChange={setLanguageIdsFilter}
          placeholder="Filter by language..."
          dropdownMatchSelectWidth={DROPDOWN_MIN_WIDTH}
        />
        <Input
          value={searchValue}
          onChange={handleFilterKeywordsBySearchValue}
          placeholder="Input search term..."
        />
      </Space>
      <Row>
        <IngredientKeywordTree
          treeData={uncategorized}
          languageOptions={languageOptions}
          keywordsType={INGREDIENT_KEYWORD_TYPES.UNCATEGORIZED}
          onAdd={onAdd}
          onRename={onRename}
          setDataForRenaming={setDataForRenaming}
          dataForRenaming={dataForRenaming}
          onCheck={onCheck}
          editable={editable}
          checkable={checkable}
          checkStrictly={checkStrictly}
          checkedKeys={checkedUncategorized}
          languageIdsFilter={languageIdsFilter}
          searchValue={searchValue}
        />
        <IngredientKeywordTree
          treeData={synonyms}
          languageOptions={languageOptions}
          keywordsType={INGREDIENT_KEYWORD_TYPES.SYNONYMS}
          onAdd={onAdd}
          onRename={onRename}
          setDataForRenaming={setDataForRenaming}
          dataForRenaming={dataForRenaming}
          onCheck={onCheck}
          editable={editable}
          checkable={checkable}
          checkStrictly={checkStrictly}
          checkedKeys={checkedSynonyms}
          languageIdsFilter={languageIdsFilter}
          searchValue={searchValue}
        />
        <IngredientKeywordTree
          treeData={varieties}
          languageOptions={languageOptions}
          keywordsType={INGREDIENT_KEYWORD_TYPES.VARIETIES}
          onAdd={onAdd}
          onRename={onRename}
          setDataForRenaming={setDataForRenaming}
          dataForRenaming={dataForRenaming}
          onCheck={onCheck}
          editable={editable}
          checkable={checkable}
          checkStrictly={checkStrictly}
          checkedKeys={checkedVarieties}
          languageIdsFilter={languageIdsFilter}
          searchValue={searchValue}
        />
        <IngredientKeywordTree
          treeData={discarded}
          languageOptions={languageOptions}
          keywordsType={INGREDIENT_KEYWORD_TYPES.DISCARDED}
          onAdd={onAdd}
          onRename={onRename}
          setDataForRenaming={setDataForRenaming}
          dataForRenaming={dataForRenaming}
          onCheck={onCheck}
          editable={editable}
          checkable={checkable}
          checkStrictly={checkStrictly}
          checkedKeys={checkedDiscarded}
          languageIdsFilter={languageIdsFilter}
          searchValue={searchValue}
        />
      </Row>
    </StyledVerticalSpace>
  )
}

IngredientKeywordTable.propTypes = {
  data: PropTypes.object.isRequired,
  dataForRenaming: PropTypes.string,
  editable: PropTypes.bool,
  checkable: PropTypes.bool,
  onAdd: PropTypes.func,
  onRename: PropTypes.func,
  onCheck: PropTypes.func,
  setDataForRenaming: PropTypes.func,
  checkedKeywordNodesGroupedByType: PropTypes.object,
  languageOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  checkStrictly: PropTypes.bool,
}

IngredientKeywordTable.defaultProps = {
  dataForRenaming: undefined,
  editable: false,
  checkable: false,
  onAdd: undefined,
  onRename: undefined,
  onCheck: undefined,
  setDataForRenaming: undefined,
  checkedKeywordNodesGroupedByType: {},
  checkStrictly: false,
}
export default IngredientKeywordTable
